import { render, staticRenderFns } from "./RTViewEmail.vue?vue&type=template&id=a565b3ea&scoped=true&lang=pug&"
import script from "./RTViewEmail.vue?vue&type=script&lang=js&"
export * from "./RTViewEmail.vue?vue&type=script&lang=js&"
import style0 from "./RTViewEmail.vue?vue&type=style&index=0&id=a565b3ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a565b3ea",
  null
  
)

export default component.exports